<template>
  <v-container fluid class="av-page">
    <div class="av-card av-panel">
      <div class="av-toolbar">
        <v-text-field
          v-model="tabela.busca"
          append-icon="search"
          label="Procurar"
          outlined
          dense
          hide-details
          single-line
          class="av-busca"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="abrirNovo">
          <v-icon left>add</v-icon>Novo plano
        </v-btn>
      </div>

      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        sort-by="nome"
        class="av-table"
        :footer-props="{
          'items-per-page-text': 'Linhas por página',
          'items-per-page-all-text': 'Tudo',
        }"
      >
        <template v-slot:[`item.valorMensal`]="{ item }">
          R$ {{ formatarValor(item.valorMensal) }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <v-chip small label :color="item.ativo ? 'success' : 'error'" text-color="white">
            {{ item.ativo ? 'Ativo' : 'Inativo' }}
          </v-chip>
        </template>
        <template v-slot:[`item.exibirLanding`]="{ item }">
          <v-icon small :color="item.exibirLanding ? 'success' : 'grey lighten-1'">
            {{ item.exibirLanding ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
          </v-icon>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="editItem(item)">
                <v-icon small color="primary">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="deleteItem(item)">
                <v-icon small color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <div class="my-4">
            <p class="av-page-subtitle mb-2">Nenhum plano para exibir.</p>
            <v-btn small depressed color="primary" @click="carregaDados">
              <v-icon left small>refresh</v-icon>Recarregar
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="dialogoPlano" persistent max-width="620px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">{{ formTitle }}</v-card-title>
        <p class="av-dialog-hint">* indica preenchimento obrigatório</p>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <span class="av-section-label">Dados do plano</span>
          <v-row class="av-form-row">
            <v-col cols="12" sm="7">
              <label class="av-field-label">Nome <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12" sm="5">
              <label class="av-field-label">Valor mensal (R$) <span class="req">*</span></label>
              <v-text-field outlined dense hide-details type="number" prefix="R$" v-model="editedItem.valorMensal"></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="av-field-label">Slug <span class="req">*</span></label>
              <v-text-field
                outlined dense hide-details
                v-model="editedItem.slug"
                placeholder="ex.: padrao, amor-saude"
                @input="normalizarSlug"
              ></v-text-field>
              <span class="av-field-help">Usado na URL de contratação: /contratar/{{ editedItem.slug || 'slug' }}</span>
            </v-col>
          </v-row>

          <v-divider class="av-form-divider"></v-divider>

          <span class="av-section-label">Disponibilidade</span>
          <v-row class="av-form-row">
            <v-col cols="12" sm="6">
              <div class="av-switch-field">
                <v-checkbox
                  v-model="editedItem.ativo"
                  :label="editedItem.ativo ? 'Ativo' : 'Inativo'"
                  dense
                  hide-details
                  class="av-check ma-0 pa-0"
                ></v-checkbox>
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="av-switch-field">
                <v-checkbox
                  v-model="editedItem.exibirLanding"
                  label="Exibir na landing page"
                  dense
                  hide-details
                  class="av-check ma-0 pa-0"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoPlano = false">Cancelar</v-btn>
          <v-btn depressed color="primary" @click="salvarPlano">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#2f7d74" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome' },
          { text: 'Slug', value: 'slug' },
          { text: 'Valor mensal', value: 'valorMensal' },
          { text: 'Ativo', value: 'ativo' },
          { text: 'Exibir na landing', value: 'exibirLanding' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
      },
      dialogoPlano: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        slug: '',
        valorMensal: '',
        ativo: true,
        exibirLanding: false,
      },
      defaultItem: {
        nome: '',
        slug: '',
        valorMensal: '',
        ativo: true,
        exibirLanding: false,
      },
    }),

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'Adicionar novo plano' : 'Editar plano'
      },
    },

    watch: {
      dialogoPlano(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          }, 300);
        }
      }
    },

    mounted() {
      this.carregaDados()
    },

    methods: {
      formatarValor(valor) {
        return Number(valor || 0).toFixed(2).replace('.', ',')
      },

      normalizarSlug() {
        this.editedItem.slug = (this.editedItem.slug || '')
          .toLowerCase()
          .replace(/[^a-z0-9-]/g, '-')
          .replace(/-+/g, '-')
      },

      async carregaDados() {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Planos?filter={"order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
      },

      abrirNovo() {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialogoPlano = true
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoPlano = true
      },

      async salvarPlano() {
        var vm = this;
        if (!this.editedItem.nome || !this.editedItem.slug || this.editedItem.valorMensal === '' || this.editedItem.valorMensal === null) {
          vm.$refs.chamaSnackbar.snack("warning", "Preencha nome, slug e valor mensal para prosseguir", "white")
          return
        }

        const payload = Object.assign({}, this.editedItem, { valorMensal: Number(this.editedItem.valorMensal) })

        this.isLoading = true
        await axios.post(baseApiUrl + 'Planos/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), payload)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.dialogoPlano = false
            vm.$refs.chamaSnackbar.snack("success", "Operação realizada com sucesso!", "white")
            this.carregaDados()
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "#BF4554")
        })
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o plano ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(baseApiUrl + 'Planos/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this;
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("success", "Operação realizada com sucesso!", "white")
            this.carregaDados()
          })
          .catch(() => {
            this.isLoading = false
          })
        }
      },
    },
  }
</script>

<style scoped>
  .av-page {
    padding: 20px 24px;
  }

  .av-panel {
    padding: 16px 16px 8px;
  }

  .av-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .av-busca { max-width: 280px; }

  @media (max-width: 599px) {
    .av-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .av-toolbar .v-spacer {
      display: none;
    }

    .av-busca {
      max-width: none;
    }

    .av-toolbar .v-btn {
      width: 100%;
    }
  }

  .av-dialog-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--av-text);
    padding-bottom: 2px;
  }

  .av-dialog-hint {
    margin: 0;
    padding: 0 16px 12px;
    font-size: 13px;
    color: var(--av-text-soft);
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin: 4px 0 10px;
  }

  .av-field-label {
    display: block;
    font-size: 12.5px;
    font-weight: 500;
    color: #2c3a3a;
    margin-bottom: 6px;
  }

  .av-field-label .req {
    color: #c62828;
  }

  .av-field-help {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    color: var(--av-text-soft);
  }

  .av-switch-field {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.38);
    padding: 6px 12px;
    min-height: 40px;
  }

  ::v-deep .av-check .v-input__slot {
    margin: 0;
  }

  ::v-deep .av-check .v-input__control {
    min-height: auto;
  }

  ::v-deep .av-check .v-label {
    color: rgba(0, 0, 0, 0.7);
  }

  .av-form-divider {
    margin: 20px 0;
  }

  ::v-deep .av-form-row > [class*="col"] {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th {
    color: var(--av-text-soft) !important;
    background: #f7f9f9;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    border-bottom: 1px solid var(--av-border) !important;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th,
  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    height: 46px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    border-bottom: 1px solid #eef1f1 !important;
    font-size: 13.5px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr:hover {
    background: #f5f8f8;
  }

  ::v-deep .av-table.v-data-table {
    background: transparent;
  }
</style>
